import React from "react";
import {
  ArrayField,
  BooleanField,
  Datagrid,
  DateField,
  ImageField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";

export const ShowComponent: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="Id" source="id" />
      <TextField label="Name" source="name" />
      <BooleanField label="Active" source="active" />
      <BooleanField label="Is Techeat" source="isTecheat" />
      <DateField label="Created at" source="created_at" />
      <DateField label="Updated at" source="updated_at" />
      <ImageField label="Logo" source="logo" />
      <ArrayField source="members">
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="user.email" />
          <TextField source="role" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
